// extracted by mini-css-extract-plugin
export var fadeInOut = "_s-3";
export var icon = "_s-4";
export var savedIndicator = "_s-2";
export var savingIndicator = "_s-0";
export var spin = "_s-1";